// These large barrel exports cause circular dependency + perf issues. We need to avoid using them.
console.warn('Used deprecated barrel export');

/*
 * Public API Surface of suvo-users-client-lib
 */

// Services
export * from './lib/suvo-users-client-lib.service';
export * from './lib/shared/services/identity/identity.service';
export * from './lib/features/users/services/users.service';
export * from './lib/shared/services/suvo-users-client-lib-settings/suvo-users-client-lib-settings.service';
export * from './lib/features/organisation/services/organisation/organisation.service';
export * from './lib/features/organisation-role/services/organisation-role.service';
export * from './lib/features/organisation-role-public/services/public-organisation-role.service';
export * from './lib/features/branch/services/branch/branch.service';
export * from './lib/features/branch-role/services/branch-role.service';
export * from './lib/features/branch/services/common-branch/common-branch.service';
export * from './lib/features/organisation/services/common-organisation/common-organisation.service';
export * from './lib/features/tenant-role/services/tenant-role.service';
export * from './lib/shared/services/print-view/print-view.service';
export * from './lib/shared/services/users-snackbar/users-snackbar.service';
export * from './lib/shared/services/users-dialog/users-dialog.service';
export * from './lib/features/tenant/services/current-tenant.service';
export * from './lib/features/tenant/services/current-tenant-role.service';
export * from './lib/features/invitations/organisations/services/organisation-invitation/organisation-invitation.service';
export * from './lib/features/subscription/services/subscription.service';
export * from './lib/features/product/services/product.service';
export * from './lib/features/users-public/services/public-users.service';
export * from './lib/features/marketing/services/marketing-email.service';
export * from './lib/features/tenant-recipe/services/tenant-recipe.service';
export * from './lib/features/tenant/services/tenant.service';

// Modules
export * from './lib/suvo-users-client-lib.module';
export * from './lib/features/authentication/modules/authentication/authentication.module';
export * from './lib/features/invitations/organisations/modules/organisation-invitation/organisation-invitation.module';
export * from './lib/features/my-account/modules/my-account.module';
export * from './lib/features/organisation/modules/organisation/organisation.module';
export * from './lib/features/subscription/modules/subscription.module';
export * from './lib/features/edit-profile/edit-profile.module';
export * from './lib/features/product/modules/product.module';
export * from './lib/features/users/modules/users.module';
export * from './lib/features/custom-domain';
export * from './lib/features/subdomain';
export * from './lib/features/verify';

// Components
export * from './lib/features/authentication/components/public/register/register.component';
export * from './lib/features/authentication/components/public/login/login.component';
export * from './lib/features/authentication/components/public/verify-email-confirmation/verify-email-confirmation.component';
export * from './lib/features/dashboard/dashboard-header.component';
export * from './lib/features/authentication/components/public/verify-mfa/verify-mfa.component';
export * from './lib/features/authentication/components/public/verify-emergency-removal-mfa/verify-emergency-removal-mfa.component';
export * from './lib/features/authentication/components/private/add-new-mfa/add-new-mfa.component';
export * from './lib/features/authentication/components/private/remove-mfa/remove-mfa.component';
export * from './lib/features/authentication/components/private/manage-mfa/manage-mfa.component';
export * from './lib/features/authentication/components/public/reset-password-confirmation/reset-password-confirmation.component';
export * from './lib/features/authentication/components/public/email-verification-message/email-verification-message.component';
export * from './lib/features/invitations/organisations/components/organisation-invitation-dialog/organisation-invitation-dialog.component';
export * from './lib/features/invitations/organisations/components/organisation-invitation-validation/organisation-invitation-validation.component';
export * from './lib/features/invitations/organisations/components/invitation-list/invitation-list.component';
export * from './lib/features/organisation/components/manage-organisations/manage-organisations.component';
export * from './lib/features/subscription/components/manage-subscription/manage-subscription.component';
export * from './lib/features/my-account/pages/edit-profile/edit-profile.component';
export * from './lib/features/organisation/components/create-organisation/create-organisation.component';
export * from './lib/features/edit-profile/components/exported/edit-names/edit-names.component';
export * from './lib/features/edit-profile/components/exported/edit-mfa/edit-mfa.component';
export * from './lib/features/edit-profile/components/common/card-entry/card-entry.component';
export * from './lib/features/authentication/components/public/verify-mfa-dialog/verify-mfa-dialog.component';
export * from './lib/features/edit-profile/components/common/password-field/password-field.component';
export * from './lib/features/edit-profile/components/dialogs/email-changed-dialog/email-changed-dialog.component';
export * from './lib/features/authentication/components/private/change-password/change-password-dialog.component';

// Models
export * from './lib/features/branch-role/models/branch-role.model';
export * from './lib/features/organisation/models/organisation-model';
export * from './lib/features/organisation-role/models/organisation-role.model';
export * from './lib/features/organisation-role-public/models/public-organisation-role.model';
export * from './lib/features/users/models/user-model';
export * from './lib/features/users-public/models/public-user-model';
export * from './lib/features/tenant-recipe/models/tenant-recipe.model';
export * from './lib/features/tenant/model/tenant.model';

// Interfaces
export * from './lib/features/authentication/interfaces/user.interface';
export * from './lib/features/authentication/interfaces/consent-box.interface';
export * from './lib/shared/interfaces/tenant-theme.interface';
export * from './lib/features/marketing/interfaces/marketing-email.interface';
export * from './lib/features/tenant-recipe/interfaces/tenant-recipe.interface';
export * from './lib/features/tenant/interfaces/tenant.interface';
export * from './lib/features/organisation/interface/organisation.interface';
